export default __webpack_public_path__ + "static/media/x-square.d852d78a.svg";